
export const fetchUser = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/me`, {
            method: "GET",
            credentials: "include",
        });

        if (!response.ok) {
            console.log("Session expired. Please log in again.");
            return null;
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching user:", error);
        return null;
    }
};

export const logoutUser = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/logout`, {
            method: "POST",
            credentials: "include",
        });

        if (!response.ok) {
            throw new Error(`Logout failed: ${response.statusText}`);
        }
        localStorage.removeItem("loginSuccess");
        window.location.href = "/login"; 
    } catch (error) {
        console.error("Error logging out:", error);
        alert(`Logout failed: ${error.message}`);
    }
}

export const logoutAllUsers = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/logoutAll`, {
            method: "POST",
            credentials: "include",
        });

        if (!response.ok) {
            throw new Error(`Logout failed: ${response.statusText}`);
        }
    } catch (error) {
        console.error("Error logging out:", error);
    }
}

export const deleteAccount = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/me`, {
            method: "DELETE",
            credentials: "include",
        });

        if (!response.ok) {
            throw new Error(`Account deletion failed: ${response.statusText}`);
        }
        localStorage.removeItem("loginSuccess");
        window.location.href = "/login"; 
    } catch (error) {
        console.error("Error deleting account:", error);
        alert(`Account deletion failed: ${error.message}`);
    }
}


